var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllSuggested10(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8127 72.375L17.9544 62.1167C17.0685 60.5458 16.8254 58.6927 17.276 56.9463C17.7266 55.2002 18.8358 53.6962 20.3711 52.7496C21.9065 51.8033 23.7486 51.4882 25.5111 51.8705C27.2737 52.2529 28.8198 53.3027 29.8252 54.8L35.3752 63.125V28.4375C35.3752 26.5976 36.1062 24.833 37.4071 23.5319C38.7082 22.2309 40.4728 21.5 42.3127 21.5C44.1525 21.5 45.9171 22.2309 47.2182 23.5319C48.5194 24.833 49.2502 26.5976 49.2502 28.4375V53.875H59.6687C63.1054 54.0424 66.3448 55.5298 68.7118 58.0267C71.0789 60.5236 72.3912 63.8376 72.3752 67.2783V72.375",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 9.9375C8.14266 9.9375 7.625 9.41984 7.625 8.78125C7.625 8.14266 8.14266 7.625 8.78125 7.625",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 9.9375C9.41984 9.9375 9.9375 9.41984 9.9375 8.78125C9.9375 8.14266 9.41984 7.625 8.78125 7.625",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 9.9375C24.3302 9.9375 23.8125 9.41984 23.8125 8.78125C23.8125 8.14266 24.3302 7.625 24.9688 7.625",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 9.9375C25.6073 9.9375 26.125 9.41984 26.125 8.78125C26.125 8.14266 25.6073 7.625 24.9688 7.625",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 26.125C8.14266 26.125 7.625 25.6073 7.625 24.9688C7.625 24.3302 8.14266 23.8125 8.78125 23.8125",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 26.125C9.41984 26.125 9.9375 25.6073 9.9375 24.9688C9.9375 24.3302 9.41984 23.8125 8.78125 23.8125",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 26.125C24.3302 26.125 23.8125 25.6073 23.8125 24.9688C23.8125 24.3302 24.3302 23.8125 24.9688 23.8125",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 26.125C25.6073 26.125 26.125 25.6073 26.125 24.9688C26.125 24.3302 25.6073 23.8125 24.9688 23.8125",
    stroke: "black",
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 42.3125C8.14266 42.3125 7.625 41.7948 7.625 41.1562C7.625 40.5177 8.14266 40 8.78125 40",
    stroke: "black",
    strokeWidth: 3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 42.3125C9.41984 42.3125 9.9375 41.7948 9.9375 41.1562C9.9375 40.5177 9.41984 40 8.78125 40",
    stroke: "black",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 42.3125C24.3302 42.3125 23.8125 41.7948 23.8125 41.1562C23.8125 40.5177 24.3302 40 24.9688 40",
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 42.3125C25.6073 42.3125 26.125 41.7948 26.125 41.1562C26.125 40.5177 25.6073 40 24.9688 40",
    stroke: "black",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1562 9.9375C40.5177 9.9375 40 9.41984 40 8.78125C40 8.14266 40.5177 7.625 41.1562 7.625",
    stroke: "black",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1562 9.9375C41.7948 9.9375 42.3125 9.41984 42.3125 8.78125C42.3125 8.14266 41.7948 7.625 41.1562 7.625",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSuggested10);
export default __webpack_public_path__ + "static/media/allSuggested10.8f6e49198c4c0382bb21c9cb0fe11850.svg";
export { ForwardRef as ReactComponent };